import { lazy } from 'react';

export const StylePageLazy = lazy(() => import('./StylePage'));
